import React, { useMemo } from 'react';
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { useItemPopover } from '../../hooks/useItemPopover';
import { WarbandMemberCard, WarbandMemberCardProps } from '../shared/WarbandMemberCard';
import { ItemDetailsPopover } from '../shared/ItemDetailsPopover';

interface WarbandMemberCardModalProps {
  open: boolean;
  onClose: () => void;
  memberCardProps: WarbandMemberCardProps;
}

export const WarbandMemberCardModal: React.FC<WarbandMemberCardModalProps> = ({
  open,
  memberCardProps,
  onClose
}) => {
  const { popover, closePopover } = useItemPopover();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" className='MemberDialog' sx={{ m: 0, p: 0, border: 0 }}>
      <DialogContent sx={{ m: 1, p: 0 }}>
        <WarbandMemberCard
          {...memberCardProps}
        />
        <ItemDetailsPopover popover={popover} onClose={closePopover} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
